module.exports = __webpack_public_path__ + "static/counter-7a234130ff5abcaf4f7af315db6b3f44.png";